import { mainIconSize } from '@/constants';
import { Button } from '@nautilusbio/nb-design-system/Button';
import { Loader, Save } from 'lucide-react';
import React from 'react';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

interface InstrumentFormDialogFooterProps {
  isPending: boolean;
  onSubmit: () => void;
}

const InstrumentFormDialogFooterComponent: FC<InstrumentFormDialogFooterProps> = ({ isPending, onSubmit }) => {
  const { t } = useTranslation('instruments');

  return (
    <Button
      data-testid="save-instrument-btn"
      isDisabled={isPending}
      onPress={onSubmit}
      visual={isPending ? 'primary' : 'success'}
    >
      {isPending ? (
        <>
          <Loader size={mainIconSize} />
          {t('saving')}
        </>
      ) : (
        <>
          <Save size={mainIconSize} />
          {t('save')}
        </>
      )}
    </Button>
  );
};

export const InstrumentFormDialogFooter = React.memo(InstrumentFormDialogFooterComponent);
